module.exports = __webpack_public_path__ + "img/file-edit-icon.22b62bcc.svg";